import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import {
  PostSuborgFields
} from "../../../../interfaces/SuperAdmin/Pages/iDataSuborganizacion";

const EditSuborgModal = () => {
  const {
    isEditSuborgModalOpen,
    toggleEditSuborgModal,
    selectedSuborg,
    suborgEdit,
    isEditingSuborg,
  } = useSuperAdminSingleOrg();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<PostSuborgFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: PostSuborgFields) => {
    if (selectedSuborg) {
      suborgEdit(data);
    }
  };

  const handleClose = () => {
    if (!isEditingSuborg) {
      reset();
      toggleEditSuborgModal(false);
    }
  };

  useEffect(() => {
    if (selectedSuborg) {
      reset({
        suborganizacion: selectedSuborg.suborganizacion,
      });
    }
  }, [selectedSuborg]);

  return (
    <Modal
      open={isEditSuborgModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Editar suborganización
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Nombres
          </Typography>
          <Controller
            name="suborganizacion"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.suborganizacion}
                helperText={errors.suborganizacion?.message}
                disabled={isEditingSuborg}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditingSuborg}
            type="submit"
          >
            {isEditingSuborg ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditSuborgModal;
